import { gql } from '@/__generated__/storefront';

export const patternProductQuery = gql(`
  query patternProducts($ids: [ID!]!, $country: CountryCode!) @inContext(country: $country) {

  nodes(ids: $ids) {
    ... on Product {
      id
      title
      productType
      handle
      priceRange {
        minVariantPrice {
          amount
          currencyCode
        }
      }
      compareAtPriceRange {
        minVariantPrice {
          amount
          currencyCode
        }
      }
      metafields(identifiers: [
        {namespace: "hobbii", key: "yarn_composition"},
        {namespace: "hobbii", key: "brand"},
        {namespace: "hobbii", key: "pattern_kind"},
        {namespace: "hobbii", key: "bulk_discounts"},
        {namespace: "hobbii", key: "entity_type"}]
        ) {
        key
        value
      }
      featuredImage {
        altText
        height
        url
        width
      }
      variants(first: 200) {
        nodes {
          id
          title
          quantityAvailable
          price {
            amount
            currencyCode
          }
          compareAtPrice {
            amount
            currencyCode
          }
          image {
            url
          }
          metafield(key: "dimensions", namespace: "hobbii") {
            value
          }
        }
      }
    }
  }
}`);

export const patternSizesQuery = gql(`
query patternSizes($patternId: ID!) {
  product(id: $patternId) {
    id
    title
    variants(first: 50) {
      nodes {
        id
        title
        metafield(key: "pattern_products", namespace: "hobbii") {
          value
        }
      }
    }
  }
}`);

export const patternProductPreviewQuery = gql(`
  query patternProductPreview($ids: [ID!]!, $country: CountryCode!) @inContext(country: $country) {

  nodes(ids: $ids) {
    ... on ProductVariant {
      id
      title
      image {
        url
      }
    }
  }
}`);
